import CryptoJS from 'crypto-js';

const AES_KEY = "1234567890123456"; // 16, 24 o 32 caracteres
const AES_IV = "1234567890123456";  // 16 caracteres            // Vector de inicialización (Base64)

export function encryptPayload(payload) {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        CryptoJS.enc.Utf8.parse(AES_KEY),
        {
            iv: CryptoJS.enc.Utf8.parse(AES_IV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    ).toString();

    return encrypted;
}
  